import React, { useEffect, useState } from 'react';
import { PageTitle, Button, Table } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { startCase } from 'lodash';

import {
  referenceAdminInstance as refAdmin,
} from '~/utils';

const ConfiguredReports = () => {
  const history = useHistory();

  const [existingConfiguredReports, setExistingConfiguredReports] = useState([]);

  const tableColumns = [{
    id: 'reportName',
    Header: 'Report Name',
    accessor: 'attributes.reportConfigurationName',
  }, {
    id: 'reportDescription',
    Header: 'Report Description',
    accessor: 'attributes.reportConfigurationDescription',
  }, {
    id: 'createSideNavItem',
    Header: '',
    accessor: () => 'Create Side Nav Item',
    Cell: c => c.value && (
      <div className="text-center" style={{ cursor: 'pointer' }}>
        {c.value} <FontAwesomeIcon icon="external-link-alt" />
      </div>
    ),
    filterable: false,
  }];

  const refreshReportList = () => {
    refAdmin
      .get('/reference-report-configuration?all-data=1')
      .then(r => r.data.data)
      .then(setExistingConfiguredReports);
  };

  useEffect(() => {
    refreshReportList();
  }, []);

  return (
    <>
      <PageTitle
        action={
          <>
            <Button
              color="info"
              target="_blank"
              href="https://docs.cordata.io/books/features/page/configuration"
            >
              <FontAwesomeIcon icon="external-link-alt" />

              <span className="d-none d-md-inline ml-2">See Documentation</span>
            </Button>

            <Button
              outline
              tag={Link}
              to="/toolbox/configured-reports/add"
            >
              <FontAwesomeIcon icon="plus" />
              <span className="d-none d-md-inline ml-2">Add Configured Report</span>
            </Button>
          </>
        }
      >
        Configured Reports
      </PageTitle>

      <Table
        data={existingConfiguredReports}
        columns={tableColumns}
        defaultSorted={[{ id: 'reportName' }]}
        filterable
        defaultFilterMethod={(filter, row) =>
          row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
        }
        getTdProps={(state, rowInfo, column) => ({
          onClick: () => {
            if (column.id === 'createSideNavItem') {
              history.push('/toolbox/side-nav-configuration', {
                createSideNavItem: {
                  appModule: 'reports',
                  navItemName: startCase(rowInfo.original.attributes.reportConfigurationName),
                  route: `reports.configured:${rowInfo.original.attributes.reportConfigurationName}`,
                },
              });
            } else {
              history.push(`/toolbox/configured-reports/${rowInfo.original.id}`);
            }
          },
        })}
      />
    </>
  );
};

export default ConfiguredReports;
